import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

export interface PaymentMethodData {
  quoteId: string;
  enrolledInAutoPay: string;
  billingData?: any;
}

@Injectable({
  providedIn: 'root',
})
export class PaymentMethodDataService {
  private paymentDataSubject = new BehaviorSubject<PaymentMethodData>({
    quoteId: '',
    enrolledInAutoPay: '',
  });

  public paymentData$ = this.paymentDataSubject.asObservable();

  setPaymentData(data: Partial<PaymentMethodData>): void {
    const currentData = this.paymentDataSubject.value;
    this.paymentDataSubject.next({ ...currentData, ...data });
  }

  getPaymentData(): PaymentMethodData {
    return this.paymentDataSubject.value;
  }

  setQuoteId(quoteId: string): void {
    this.setPaymentData({ quoteId });
  }

  setEnrolledInAutoPay(enrolled: string): void {
    this.setPaymentData({ enrolledInAutoPay: enrolled });
  }

  setBillingData(billingData: any): void {
    this.setPaymentData({ billingData });
  }
}
